package com.exura.features.legacyplans.data.remote.dto

import com.exura.features.firebase.data.remote.dto.SerializableDto
import com.exura.features.legacyplans.domain.model.TimelyCheckup
import com.exura.features.legacyplans.domain.model.TimelyRestriction
import com.exura.features.legacyplans.domain.model.TimelyTask
import kotlinx.serialization.Serializable

@Serializable
data class DetailedPlanDto(
    var id: String,
    val title: String,
    val shortDescription: String,
    val tasks: List<TimelyTask>,
    val checkups: List<TimelyCheckup>,
    val restrictions: List<TimelyRestriction>,
    val status: String = "pending",
) : SerializableDto
